import { Currency } from '@shared/api';
import { Asset } from '@shared/api/@types/markets';

export const isCurrencyAsset = (currency?: Asset | Currency): currency is Asset =>
  (currency as Asset)?.assetType !== undefined;
